import useSnackbar from 'hooks/useSnackbar';
import { validationListKey } from 'react_query/query-keys';
import { validationSingleSubmission } from 'services/reactQueryservices';
import { client } from 'react_query/query-client-configuration';
import { useMutation } from '@tanstack/react-query';

const useValidationSingleSubmission = () => {
    const snackbar = useSnackbar();
    const { mutate, error, isSuccess, isError, isLoading } = useMutation({
        mutationFn: validationSingleSubmission,
        onSettled: (data, error) => {
            if (error) {
                snackbar('Something went wrong', 'error');
            } else {
                client.invalidateQueries({ queryKey: [validationListKey] });
                snackbar('Operation Successful');
            }
        }
    });
    return {
        mutate,
        error,
        isSuccess,
        isError,
        isLoading
    };
}

export default useValidationSingleSubmission